"use strict";
(() => {
  const familyYears = {
    Polaris: { Ranger: 1998, RZR: 2008, General: 2016 },
    "Can-Am": { Defender: 2016, Commander: 2011, Maverick: 2013 },
    CFMoto: { "UForce Pro": 2025, "UForce Highland": 2025 }
  };
  const canonicalMake = make => make === "Can-Am / BRP" ? "Can-Am" : make;
  const option = (value, label = value) => new Option(label, value);
  const params = () => new URLSearchParams(location.search);
  const nextModelYear = () => new Date().getFullYear() + 1;

  function mountPicker(root) {
    if (root.dataset.sxsPickerMounted) return;
    const make = canonicalMake(root.dataset.make);
    if (!familyYears[make]) return;
    const form = root.querySelector("[data-sxs-form]");
    const year = root.querySelector("[data-sxs-year]");
    const model = root.querySelector("[data-sxs-model]");
    const otherYearField = root.querySelector("[data-sxs-other-year-field]");
    const otherYear = root.querySelector("[data-sxs-other-year]");
    const status = root.querySelector("[data-sxs-status]");
    const request = root.querySelector("[data-request-form]");
    if (!form || !year || !model || !otherYear || !status || !request) return;
    const choices = [...model.options].filter(item => item.dataset.url).map(item => ({
      name: item.value,
      url: item.dataset.url,
      firstYear: familyYears[make][item.value]
    })).filter(item => Number.isInteger(item.firstYear));
    if (!choices.length) return;
    root.dataset.sxsPickerMounted = "true";
    const selectedYear = () => year.value === "not-listed" ? otherYear.value : year.value;
    const validYear = () => /^\d{4}$/.test(selectedYear()) && Number(selectedYear()) >= 1900 && Number(selectedYear()) <= nextModelYear();
    const hideRequest = () => {
      if (!request.querySelector(".machine-finder__form-message")) request.hidden = true;
    };
    const showRequest = () => {
      const details = { category: root.dataset.categoryLabel, make, year: selectedYear(), model: model.value === "not-listed" ? root.dataset.unlisted : model.value, track: "" };
      Object.entries(details).forEach(([key, value]) => {
        const field = root.querySelector(`[data-contact-field="${key}"]`);
        if (field) field.value = value;
      });
      const summary = root.querySelector("[data-selection-summary]");
      if (summary) summary.textContent = Object.values(details).filter(Boolean).join(" / ");
      request.hidden = false;
      status.textContent = root.dataset.requestText;
      root.querySelector('[name="contact[Unlisted model]"]')?.focus({ preventScroll: true });
    };
    const populateModels = () => {
      model.replaceChildren(option("", root.dataset.chooseModel));
      choices.filter(item => Number(selectedYear()) >= item.firstYear).forEach(item => {
        const entry = option(item.name);
        entry.dataset.url = item.url;
        model.add(entry);
      });
      model.add(option("not-listed", root.dataset.unlisted));
      model.disabled = !validYear();
      hideRequest();
      status.textContent = root.dataset.selectionText;
    };
    const navigate = () => {
      if (!form.reportValidity() || !validYear() || !model.value) return;
      if (model.value === "not-listed") { showRequest(); return; }
      const choice = choices.find(item => item.name === model.value && Number(selectedYear()) >= item.firstYear);
      if (!choice) return;
      const url = new URL(choice.url, location.origin);
      if (url.origin !== location.origin) return;
      const values = { category_key: "sxs", make, year: selectedYear(), model: choice.name, finder_year: selectedYear(), finder_model: choice.name };
      Object.entries(values).forEach(([key, value]) => url.searchParams.set(key, value));
      const preview = root.dataset.previewThemeId || params().get("preview_theme_id");
      if (preview) url.searchParams.set("preview_theme_id", preview);
      location.assign(url.toString());
    };
    year.replaceChildren(option("", root.dataset.chooseYear));
    const firstYear = Math.min(...choices.map(item => item.firstYear));
    for (let value = nextModelYear(); value >= firstYear; value--) year.add(option(String(value)));
    year.add(option("not-listed", root.dataset.yearNotListed));
    year.disabled = false;
    const updateYear = () => {
      otherYearField.hidden = year.value !== "not-listed";
      otherYear.disabled = otherYearField.hidden;
      otherYear.required = !otherYearField.hidden;
      otherYear.max = String(nextModelYear());
      populateModels();
    };
    year.addEventListener("change", updateYear);
    otherYear.addEventListener("input", populateModels);
    model.addEventListener("change", () => {
      hideRequest();
      status.textContent = root.dataset.selectionText;
      if (model.value) navigate();
    });
    form.addEventListener("submit", event => { event.preventDefault(); navigate(); });
    const saved = params();
    const savedYear = saved.get("finder_year") || saved.get("year");
    const savedModel = saved.get("finder_model") || saved.get("model");
    if ([...year.options].some(item => item.value === savedYear)) year.value = savedYear;
    else if (/^\d{4}$/.test(savedYear || "")) { year.value = "not-listed"; otherYear.value = savedYear; }
    updateYear();
    if ([...model.options].some(item => item.value === savedModel)) model.value = savedModel;
  }

  function mountResults(root) {
    if (root.dataset.sxsResultsMounted) return;
    root.dataset.sxsResultsMounted = "true";
    const saved = params();
    const parent = root.dataset.sxsParentUrl?.split("/").filter(Boolean).at(-1);
    const make = { "sxs-polaris-graphics": "Polaris", "sxs-can-am-brp-graphics": "Can-Am", "sxs-cfmoto-graphics": "CFMoto" }[parent];
    const model = root.dataset.sxsModel;
    const year = saved.get("year") || saved.get("finder_year");
    const firstYear = familyYears[make]?.[model];
    if (!firstYear || !/^\d{4}$/.test(year || "") || Number(year) < firstYear || Number(year) > nextModelYear()) return;
    const heading = root.querySelector("h1");
    if (heading) heading.textContent = `${year} ${make} ${model} ${root.dataset.sxsGraphicsLabel}`;
    const back = root.querySelector(".bp-chassis-hero__back");
    if (back) {
      const url = new URL(back.href);
      url.searchParams.set("finder_year", year);
      url.searchParams.set("finder_model", model);
      const preview = root.dataset.previewThemeId || saved.get("preview_theme_id");
      if (preview) url.searchParams.set("preview_theme_id", preview);
      back.href = url.toString();
    }
    const updateProductLink = link => {
      const url = new URL(link.href, location.origin);
      if (url.origin !== location.origin || !url.pathname.includes("/products/")) return;
      Object.entries({ category_key: "sxs", make, year, model }).forEach(([key, value]) => url.searchParams.set(key, value));
      const preview = root.dataset.previewThemeId || saved.get("preview_theme_id");
      if (preview) url.searchParams.set("preview_theme_id", preview);
      link.href = url.toString();
    };
    root.querySelectorAll('a[href*="/products/"]').forEach(updateProductLink);
    root.addEventListener("click", event => {
      const link = event.target.closest?.("a[href]");
      if (link && root.contains(link)) updateProductLink(link);
    }, true);
  }

  function restoreProductSelection(root) {
    const saved = params();
    const make = { polaris: "Polaris", "can-am": "Can-Am", cfmoto: "CFMoto" }[root.dataset.machineKey?.split("/")[1]];
    const model = root.dataset.chassis;
    const year = saved.get("year");
    const firstYear = familyYears[make]?.[model];
    if (!firstYear || saved.get("category_key") !== "sxs" || canonicalMake(saved.get("make")) !== make || saved.get("model") !== model || !/^\d{4}$/.test(year || "") || Number(year) < firstYear || Number(year) > nextModelYear()) return;
    Object.entries({ Year: year, Model: model }).forEach(([key, value]) => {
      const field = root.querySelector(`input[name="properties[${key}]"]`);
      if (field && !field.value) {
        field.value = value;
        field.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  const mount = (scope = document) => {
    const find = selector => [...(scope.matches?.(selector) ? [scope] : []), ...scope.querySelectorAll(selector)];
    find("[data-sxs-picker]").forEach(mountPicker);
    find("[data-sxs-results]").forEach(mountResults);
    find('[data-fresh-start-fitment][data-machine-key^="sxs/"]').forEach(restoreProductSelection);
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => mount(), { once: true });
  else mount();
  document.addEventListener("shopify:section:load", event => mount(event.target));
  window.addEventListener("pageshow", () => mount());
})();
